export default {
  'modifyProfile.member_profile': 'ข้อมูลสมาชิก',
  'modifyProfile.error.modify_fail': 'ไม่สามารถแก้ไขข้อมูลได้ กรุณาลองใหม่อีกครั้ง',
  'modifyProfile.error.different_phone_number': 'กรุณากรอกหมายเลขโทรศัพท์ใหม่ที่แตกต่างจากเดิม',
  'modifyProfile.modify': 'แก้ไขข้อมูล',
  'modifyProfile.submit': 'ยืนยันการแก้ไข',
} as Record<string, string>;
